import { createAsyncThunk } from "@reduxjs/toolkit";
import { SelectedFile } from "../../../@types/selectedFile";

export const addDocInfo = createAsyncThunk(
    "adduploadedDocument",
    async (file: SelectedFile[]) => {
        return file
    }
  );